import { render, staticRenderFns } from "./dettaglio.vue?vue&type=template&id=78f06df2&scoped=true&"
import script from "./dettaglio.vue?vue&type=script&lang=js&"
export * from "./dettaglio.vue?vue&type=script&lang=js&"
import style0 from "./dettaglio.vue?vue&type=style&index=0&id=78f06df2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f06df2",
  null
  
)

export default component.exports